import {
  resolveDynamicFlag,
  useDynamicFlag,
} from "@/utils/featureFlagOverride";

export const SKU_STORE_STORIES_FLAG_KEY = "VITE_FF_ENABLE_SKU_STORE_STORIES";

const skuStoreStoriesEnvValue =
  import.meta.env.VITE_FF_ENABLE_SKU_STORE_STORIES === "true";

export const isSkuStoreStoriesEnabled = () =>
  resolveDynamicFlag(SKU_STORE_STORIES_FLAG_KEY, skuStoreStoriesEnvValue);

export const useIsSkuStoreStoriesEnabled = () =>
  useDynamicFlag(SKU_STORE_STORIES_FLAG_KEY, skuStoreStoriesEnvValue);
